export default {
    path : "factory-carrier-focus",
    name : "factory-carrier-focus",
    meta : {
        title : "关注载体"
    },
    component: () => import('@/pages/factory/focusCarrier/Index'),
    redirect: {
        name : "factory-carrier-focus-whole"
    },
    children: [
        {
            path: 'all',
            name: 'factory-carrier-focus-whole',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'recent',
            name: 'factory-carrier-focus-recent',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'atme',
            name: 'factory-carrier-focus-atme',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'meat',
            name: 'factory-carrier-focus-meat',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'reply',
            name: 'factory-carrier-focus-reply',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'search',
            name: 'factory-carrier-focus-search',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'update',
            name: 'factory-carrier-focus-update',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/factory/focuscarrier/index.js